function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment } from 'react';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { TickIcon } from '@domain-group/fe-co-icon';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import { ListingType, ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { BtrPill, ListingInfoPill, PriceGuidePill } from '@domain-group/fe-co-allhomes-shared-components';
import { AllhomesListingCardAddress, AllhomesListingCardFeatures, AllhomesListingCardImages, AllhomesListingCardAgencyDetails } from './components';
import pageWrapper from './wrappers';
import * as styles from './search-result-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseAllhomesSearchListingCard = _ref => {
  var listing = _ref.listing,
    address = _ref.address,
    property = _ref.property,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$onAddToWatchlist = _ref.onAddToWatchlist,
    onAddToWatchlist = _ref$onAddToWatchlist === void 0 ? () => {} : _ref$onAddToWatchlist,
    agency = _ref.agency,
    agencies = _ref.agencies,
    development = _ref.development,
    _ref$openInNewTab = _ref.openInNewTab,
    openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
    _ref$watchlistPopupAl = _ref.watchlistPopupAlignment,
    watchlistPopupAlignment = _ref$watchlistPopupAl === void 0 ? 'center' : _ref$watchlistPopupAl,
    _ref$isInInspectionPl = _ref.isInInspectionPlan,
    isInInspectionPlan = _ref$isInInspectionPl === void 0 ? () => false : _ref$isInInspectionPl,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'horizontal' : _ref$appearance,
    className = _ref.className;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref2 = useAllhomesApi() || {},
    _ref2$toggledFeatures = _ref2.toggledFeatures,
    toggledFeatures = _ref2$toggledFeatures === void 0 ? {} : _ref2$toggledFeatures;
  var pluralize = (count, singular, plural) => count === 1 ? singular : plural;
  var listingType = listing.type;
  var showShareStats = listingType === ListingType.SHARE_RESIDENTIAL.name;
  var buildPhotoAlt = _ref3 => {
    var street = _ref3.street,
      suburb = _ref3.suburb,
      state = _ref3.state,
      postcode = _ref3.postcode;
    var streetWithComma = street ? "".concat(street, ",") : '';
    return [streetWithComma, suburb, state, postcode].filter(value => value).join(' ').trim();
  };
  var hasInspection = Boolean(!isEmpty(listing.events) && listing.events[0].startTime);
  var inspectionDate = hasInspection && listing.events[0].startTime || undefined;
  var isBtr = (development === null || development === void 0 ? void 0 : development.type) === 'RENTAL';
  var nextInspectionFormatted = inspectionDate && moment(inspectionDate).format('ddd D MMM, h:mm A');
  var eventData = {
    address,
    property,
    agency,
    listing,
    price: listing.priceLabel
  };
  var anchorAttributes = {};
  if (openInNewTab) {
    anchorAttributes.target = '_blank';
    anchorAttributes.rel = 'noreferrer noopener';
  }
  var getAgencyDetails = () => {
    if (development && agencies && agencies.length > 1) {
      return {
        url: listing.url,
        logo: development.logo,
        type: 'Agent'
      };
    }
    return _objectSpread({}, agency);
  };
  var renderPills = () => {
    var _listing$events, _listing$events$;
    var inInspection = isInInspectionPlan({
      listingId: listing.id,
      startTime: (_listing$events = listing.events) === null || _listing$events === void 0 ? void 0 : (_listing$events$ = _listing$events[0]) === null || _listing$events$ === void 0 ? void 0 : _listing$events$.startTime
    });
    var showPriceGuide = toggledFeatures[ToggledFeatureKey.PRICE_GUIDE] && Boolean(listing.priceGuide);
    return (hasInspection || showPriceGuide || isBtr) && ___EmotionJSX("div", {
      css: styles.pills
    }, isBtr && ___EmotionJSX(BtrPill, null), hasInspection && ___EmotionJSX(ListingInfoPill, {
      icon: inInspection ? ___EmotionJSX(TickIcon, {
        size: "small"
      }) : undefined,
      label: ___EmotionJSX("span", {
        itemProp: "name"
      }, inInspection ? 'In my planner' : 'Open'),
      details: ___EmotionJSX("span", {
        itemProp: "startDate",
        content: inspectionDate
      }, nextInspectionFormatted),
      ctaIcon: ___EmotionJSX(Fragment, null)
    }), showPriceGuide && ___EmotionJSX(PriceGuidePill, {
      priceGuide: listing.priceGuide
    }));
  };
  return ___EmotionJSX("div", {
    itemScope: hasInspection,
    itemType: hasInspection ? 'http://schema.org/Event' : undefined,
    css: styles.searchResultCard(appearance),
    className: className
  }, ___EmotionJSX("div", {
    css: styles.image(appearance)
  }, ___EmotionJSX(AllhomesListingCardImages, {
    appearance: appearance,
    firstImage: listing.firstImage,
    has3dTour: listing.has3dTour,
    hasVideo: listing.hasVideo,
    numPhotos: listing.numPhotos,
    alt: buildPhotoAlt(address),
    anchorAttributes: anchorAttributes,
    listingId: listing.id,
    onAddToWatchlist: onAddToWatchlist,
    watchlistPopupAlignment: watchlistPopupAlignment
  }, ___EmotionJSX("div", {
    css: styles.badges
  }, ___EmotionJSX(AllhomesListingBadges, {
    annotations: listing.annotations,
    labelType: "short"
  })))), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.detailsAgency
  }, ___EmotionJSX("div", {
    css: styles.details(appearance)
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.detailsPrice
  }, listing.priceLabel), ___EmotionJSX(AllhomesListingCardAddress, _extends({
    href: listing.url,
    onClick: evt => {
      sendEvent('listing-click', eventData);
      _onClick(listing.id);
      evt.stopPropagation();
    },
    listingId: listing.id,
    anchorAttributes: anchorAttributes
  }, address)), ___EmotionJSX(AllhomesListingCardFeatures, _extends({}, property, {
    listingType: listingType
  })), showShareStats && listing.roomsAvailable && ___EmotionJSX("span", {
    css: styles.shareFeature
  }, ___EmotionJSX("span", {
    css: styles.shareValue
  }, listing.roomsAvailable), "\xA0", pluralize(listing.roomsAvailable, 'room', 'rooms'), " available"), showShareStats && listing.peopleWanted && ___EmotionJSX("span", {
    css: styles.sharePeopleWanted
  }, ___EmotionJSX("span", {
    css: styles.shareValue
  }, listing.peopleWanted), "\xA0", pluralize(listing.roomsAvailable || 0, 'person', 'people'), ' ', "wanted")), appearance === 'horizontal' && renderPills()), ___EmotionJSX(AllhomesListingCardAgencyDetails, _extends({
    appearance: appearance,
    onClick: () => {
      sendEvent('agency-click', eventData);
    }
  }, getAgencyDetails()))), appearance === 'vertical' && renderPills()));
};
export var AllhomesSearchListingCard = pageWrapper()(BaseAllhomesSearchListingCard);